import { v4 as uuidv4 } from "uuid";
import { getTenant } from "./tenantUtils";
import { UserAction } from "./analytics";
import { getUtcTimestamp } from "./utils";

class Tracing {
  private readonly anonymousIdKey = "NG-AnonymousId";
  private readonly sessionIdKey = "NG-SessionId";
  private readonly sessionTimestampKey = "NG-SessionTimestamp";
  private readonly requestIdKey = "NG-RequestId";
  public newSessionCreated = false;
  private contextAction?: UserAction;

  createAnnonymousId() {
    const id = this.getFromSessionStore(this.anonymousIdKey);
    if (!id) {
      this.saveToSessionStore(this.anonymousIdKey, uuidv4());
    }
  }

  setContextAction(action: UserAction) {
    this.contextAction = action;
  }

  createSessionId() {
    this.saveToLocalStore(this.sessionIdKey, uuidv4());
    this.saveToLocalStore(this.sessionTimestampKey, Date.now().toString());
    this.newSessionCreated = true;
  }

  clearSessionId() {
    this.removeFromLocalStore(this.sessionIdKey);
    this.removeFromLocalStore(this.sessionTimestampKey);
  }

  getSessionId() {
    return this.getFromLocalStore(this.sessionIdKey);
  }

  getSessionElapsedTime() {
    const timestamp = this.getFromLocalStore(this.sessionTimestampKey);
    if (!timestamp) {
      return undefined; // No session timestamp found
    }
    return Date.now() - parseInt(timestamp, 10);
  }

  getHeaders(userAction?: UserAction) {
    const anonymousId = this.getFromSessionStore(this.anonymousIdKey) ?? "";
    const sessionId = this.getSessionId() ?? "";

    const action = userAction ?? this.contextAction;

    return {
      [this.anonymousIdKey]: anonymousId,
      [this.sessionIdKey]: sessionId,
      [this.requestIdKey]: uuidv4(),
      Tenant: getTenant(),
      ...(action ? { "NG-ActionId": action.Id } : {}),
      "NG-ClientTimestamp": getUtcTimestamp()
    };
  }

  private saveToSessionStore(key: string, value: string) {
    if (typeof sessionStorage != "undefined") {
      sessionStorage.setItem(key, value);
    }
  }

  private getFromSessionStore(key: string) {
    if (typeof sessionStorage != "undefined") {
      return sessionStorage.getItem(key);
    }
    return null;
  }

  private saveToLocalStore(key: string, value: string) {
    if (typeof localStorage != "undefined") {
      localStorage.setItem(key, value);
    }
  }

  private removeFromLocalStore(key: string) {
    if (typeof localStorage != "undefined") {
      localStorage.removeItem(key);
    }
  }

  private getFromLocalStore(key: string) {
    if (typeof localStorage != "undefined") {
      return localStorage.getItem(key);
    }
    return null;
  }
}

const tracing = new Tracing();
export default tracing;
